module.exports = __webpack_public_path__ + "media/images/icons/ig-1c738eefe321eb12e01416714887cca4.svg";